export const parseAmount=(stringValue)=>{
    if (typeof stringValue !== 'string') return stringValue;
    return parseFloat(stringValue.replace(/,/g, ''));
}